/**
 * Created by agengmaulana on 7/20/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import Slider from 'react-slick';
import Comment_Article from './comment_article.js'

// @observer
export default class Comment_Article_Master extends React.Component {


    render() {
        const {dataStore,datastoresVerified} = this.props;

        const settings = {
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay:true,
          autoplaySpeed:15000,
          arrows: false,
          cssEase: 'linear',
          className:['slide_pilred','slick-dotted'],
        }
        return(
            <div className={styles.cmt_pilred +' '+styles.cmt_mb15} >
                 <Slider {...settings}>
                    {
                        dataStore.datastores.length ?
                                    dataStore.datastores.map((data, i) =>
                                        <Comment_Article key={data.id} data={data} datFunction={dataStore} datastoresVerified={datastoresVerified}/>
                                    )
                            : ''
                    }
                  </Slider>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_article/comment_article_master.js